<template>
	<div class="page">

		<!-- <left-sidebar></left-sidebar>  -->
		<div>
			<div class="sidebar-wrapper">
				<h3>Оповещания</h3>
				<ul class="ul-sidebar">


            <li v-for="(item, index) in navigation" :key="item.id" >
            	<router-link :to="{ name: item.name }">{{ item.title }} <span class="count-values">{{ item.value }}</span></router-link>
            </li>



        </ul>
       <!--  <div>
            <div class="bottom-sidebar">
                <div>Отправка файлов:</div>
                <div class="wrap-progress-bar">
 
                    <span class="fileProgress"></span>
                    <hr>
                    Элементов в папке: 
                    
                </div>
                
            </div>
        </div> -->
    </div>
</div>
<!-- END LEFT SIDEBAR -->

<div class="page-content-wrap">
	<nav v-show="globalLoading == false">
		<div>

			<div v-if="checkBoxesState" style="margin-bottom: 1rem;">
				<ul class="breadcrumbs remaining-count">
					<li><input @change="checkAll()" type="checkbox" :checked="checkBoxesState" id="aaaaaaa" class="cbx" style="display: none;">
						<label for="aaaaaaa" class="check">
							<svg width="14px" height="14px" viewBox="0 0 18 18">
								<path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path>
								<polyline points="1 9 7 14 15 4"></polyline>
							</svg>
						</label>
					</li>
					<li><h1>{{checkBoxesState}} checked items</h1></li>
				</ul>
			</div>

			<ul class="breadcrumbs" v-else>
				<li><input @change="checkAll()" type="checkbox" id="aaaaaaa" class="cbx" style="display: none;">
					<label for="aaaaaaa" class="check">
						<svg width="14px" height="14px" viewBox="0 0 18 18">
							<path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path>
							<polyline points="1 9 7 14 15 4"></polyline>
						</svg>
					</label>
				</li>
				<li><h1 class="">{{title}}</h1></li>
			</ul>
			<!-- END checked left menu for links -->

			<!-- checked right menu for links -->
			<ul v-if="!checkBoxesState" class="buttons-do l-fe" >
				<li v-if="can.create"> <i aria-hidden="true" class="fa fa-plus-square-o"></i> <router-link :to="{ name: can.create.name }"> {{ can.create.title }} </router-link></li>
			</ul>

			<ul  class="buttons-do l-fe" v-else>
				<li v-if="can.copy" @click="massActItem('copy')"> <i aria-hidden="true" class="fa fa-files-o"></i> Копирай</li>
				<li v-if="can.copy" @click="massActItem('copy')"> <i class="fa fa-plus" aria-hidden="true"></i> Копирай</li>
				<li v-if="can.changeStatus0" @click="copyrightPanel = true"><i class="fa fa-usd" aria-hidden="true"></i> Копирайт</li>
				<li v-if="can.remove" @click="massActItem('remove')"> <i class="fa fa-trash-o" aria-hidden="true"></i> Изтрий</li>
				<li v-if="can.changeStatus1" @click="massActItem('status-on')"><i class="fa fa-power-off status colorGreen" aria-hidden="true"></i> Включи</li>
				<li v-if="can.changeStatus0" @click="massActItem('status-off')"><i class="fa fa-power-off status " aria-hidden="true"></i> Изключи</li>

			</ul>
			<!-- END checked right menu for links -->

			<!-- <mode ></mode> -->
			<!-- pagination button -->
			<ul v-if="items.data && items.data.length != 0" class="buttons-do" >
				<li v-if="items.last_page != 1"><input class="input-page-number" type="text" v-model="activePage" @keyup.enter="changePageNumber(activePage)"> / {{ items.last_page }} </li>

				<li v-if="items.from"> {{items.from }} - {{items.to }} из {{items.total }} </li>

				<li v-if="items.prev_page_url" @click="changePageNumber('prev')"> <i class="fa fa-chevron-left" aria-hidden="true"></i> </li>
				<li v-else=""> <i style="color:#ccc" class="fa  fa-chevron-left" aria-hidden="true"></i> </li>


				<li v-if="items.next_page_url != null" @click="changePageNumber('next')"> <i  class="fa fa-chevron-right" aria-hidden="true"></i> </li>
				<li v-else=""> <i style="color:#ccc " class="fa  fa-chevron-right" aria-hidden="true"></i> </li>
			</ul>

		</div>


		<!-- FILTER MENU START -->

		<filter-items v-if="this.$route.name == 'shop-product'" @exportItems="exportItems"></filter-items>


		<!-- FILTER MENU END -->


	</nav>
	<div class="content-place">

		<copyrightAddTask v-if="copyrightPanel && checkBoxValue.length != 0" :checkBoxValue="checkBoxValue" @done="done"></copyrightAddTask>

		<div v-if="loading" class="lds-dual-ring spinner"></div>

		<div v-show="loading == false">
			<div  class="table-content-place">

				<draggable
				class="dragArea "
				:list="items.data"
				group="people"
				>

				<div  v-for="(item, index) in items.data" :key="item.id"  class="ml0 row table header-table card-img-top imgs-sortable">

					<div class="col-lg-1" style="text-align:right">

						<input @change="changeStateCheckbox(item.id)" v-model="item.check" type="checkbox" :id="item.id" class="cbx" style="display: none;">
						<label :for="item.id" class="check">
							<svg width="14px" height="14px" viewBox="0 0 18 18">
								<path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path>
								<polyline points="1 9 7 14 15 4"></polyline>
							</svg>
						</label>

						<!-- <img :src="item.images" alt=""> -->
						<!-- <i class="fa fa-exclamation-triangle col-icon error-icon" aria-hidden="true"></i> -->

<i v-if="item.icon == 'access'" class="fa fa-check-square-o access-icon col-icon " aria-hidden="true"></i>
<i v-if="item.icon == 'error'" class="fa fa-exclamation-triangle error-icon col-icon " aria-hidden="true"></i>

					</div>
					<div v-if="$route.name != 'system-notification'" class="col-lg-4 name" >
						<span :title="item.param1">{{ item.param1 }}</span>
						<span class="type-folder"> <!-- <i @click="changeStatus(item.id)" class="fa fa-power-off status" :class="{colorGreen: item.status == 1}" aria-hidden="true"></i> --> {{ statusName(item.status) }}</span>
					</div>

					<div class="col-lg-8">
						<h6 class="title-notification" v-html="item.param2"></h6>
						<span v-html="item.param3"></span>
					</div>
					
					<div class="col-lg-2">
						<span class="table-date">{{ item.created_at }}</span>
						<ul class="ul-hover-option-table">
							
							<li v-if="can.edit">
								<router-link :to="{ name: can.edit.name, params: { id: item.id }  }"> <i class="fa fa-pencil-square-o color-grey" aria-hidden="true"></i></router-link>
							</li>
							<li v-if="can.copy" @click="oneActItem(item.id,'copy')"><i aria-hidden="true" class="fa fa-files-o color-grey"></i></li>
							<li v-if="can.remove" @click="oneActItem(item.id,'remove')"><i aria-hidden="true" class="fa fa-trash-o color-grey"></i></li>


						</ul>

							</div>


						</div>
					</draggable>


				</div>

			</div>

			<div>
				<div class="empty-folder" v-if="items.data && items.data.length == 0 && loading == false">
					<img src="http://perpao.com/empty-folder.png" alt="">
					<div class="content-empty-folder">
						<h3>Нищо не намерено</h3>

					</div>

				</div>
			</div>

		</div>


	</div>



</div>
</template>

<script>

	import axios from 'axios'


	import mode from '../../../components/layouts/mode'
	import copyrightAddTask from '../../../components/layouts/forms/copyright/createTask'
	import filterItems from '../../../components/layouts/forms/list/filter'

	import LeftSidebar from '../../../components/layouts/LeftSidebar'

	import database from '../../../mixins/database'
	import sortable from '../../../mixins/sortable'
	import general from '../../../mixins/system/general'

	export default {
		name: 'list',

		data() {
			return {
				// send: this.$store.getters.getDomainName+ 'core/get/'+this.$route.name,

				dataBase: {
					paginate: 50,
				},

               // checkBoxesState: true,
               activeOptions: false,
               sortable: true,
               /**  From mixins available is currect domain, items  */

               // nameItemsms: 'shop-product',
               title: 'qqq',

           }
       },

       created() {
       },

       
       components: {
       	LeftSidebar,
       	mode,
       	copyrightAddTask,
       	filterItems,

       },

       methods: {
       	
       	done() {
       		this.copyrightPanel = false

       		for(var i = 0;i < this.checkBoxValue.length;i++) {

       			for (var j = this.items.data.length - 1; j >= 0; j--) {
       				if(this.items.data[j].id == this.checkBoxValue[i].id) {

       				}
       				this.items.data[j]['check'] = false

       			}
       		}

       		this.checkBoxValue = []

       	},
       	statusName(status) {


       		if(status == 0) {
       			return 'Изключен'
       		}

       		if(status == 1 ) {
       			console.log(status)

       			return 'Включен'
       		}

       		if(status == 6 ) {
       			console.log(status)

       			return 'В процес копирайтера'
       		}

       		if(status == 2 ) {
       			return 'Доступен [copyright]'
       		}

       		if(status == 3 ) {
       			return 'На проверка [copyright]'
       		}

       		if(status == 4 ) {
       			return 'На коррекция [copyright]'
       		}

       		if(status == 5 ) {
       			return 'Готов [copyright]'
       		}

       	},


       },

       computed: {

       },

        // mixins - database - get ( sortable: true / false ). 
        mixins: [database, sortable, general],



    }

</script>

<style scoped src="../../../assets/css/page-index.css"></style>
<style scoped src="../../../assets/css/table.css"></style>
<style scoped>
.title-notification {
	font-size:13px;
}
.access-icon {
	color:#4fc08d96!important;
}
.col-icon {
	font-size: 25px!important;
	    padding: 13px;
}
.error-icon {
	font-size: 25px!important;
	    padding: 13px;
	color:#fbb5b8!important;
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/tables/Notification.vue